import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import { KnowledgeBaseQaPairCategory } from 'uplisting-frontend/models/ai-knowledge-base-qa-pair';

export class KnowledgeCenterCategoryFilter extends MultiSelectListFilter {
  id = FilterId.knowledgeCenterCategory;
  optionsType = FilterOptionsType.list;
  optionsList = Object.values(KnowledgeBaseQaPairCategory);
}
